import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import MobileStickyCTA from './MobileStickyCTA';

export default function PublicLayout() {
  return (
    <div className="flex flex-col min-h-screen bg-[#FAFBFC]">
      <Header />
      {/* Reserve room at the bottom on mobile so the sticky CTA never covers footer/content. */}
      <main className="flex-1 pb-20 md:pb-0">
        <Outlet />
      </main>
      <Footer />
      <MobileStickyCTA />
    </div>
  );
}
